module.exports = __webpack_public_path__ + "fonts/aveny-tinstagram-medium-webfont.6a1cc6f9.eot";